import { ACTIONS_TRANSLATE } from "./actions";
import { BREADCRUMBS_TRANSLATE } from "./breadcrumbs-translate";

export const GENERIC_TRANSLATIONS: any = {
	...BREADCRUMBS_TRANSLATE,
	root: {
		language: "es-ES",
		noscript: "Para ver esta aplicación, por favor habilite JavaScript.",
		title: "{{ projectName }}",
		projectName: "Fale Seguro",
		metas: {
			description: `Usted quiere información, quiere un equipo organizado, productivo y motivado.
			Su empresa necesita JoinIn. Una plataforma de productividad y contenido
			que facilita procesos y agiliza la comunicación con los equipos.`,
			keywords: `JoinIn, herramientas, espacios, interacción, comunicación, relaciones,
			publicaciones, contacto, información, organización, productivo, motivado,
			procesos, agiliza, equipos, estructura dinámica, personalizable, servicios,
			autoservicio, recursos humanos, mural digital, red social, red social
			corporativa, central de servicio, viajes, digital, intranet, integración,
			aprobaciones, solicitudes, personas, transformación, descentralización, desburocratización,
			estrategias, negocios`,
			author: "JoinIn",
			copyright: "JoinIn"
		},
		workWithUs: {
			first: "¡Equipo de JoinIn aquí!",
			second: "Trabaja con nosotros: http://joinin.com.br.",
			third: "#wearejoinin"
		}
	},

	errorDialog: {
		title: "Atención"
	},
	generic: {
		...ACTIONS_TRANSLATE,
		noResults: {
			label: "No se ha agregado ninguna información",
			description: "Cuando se agreguen, aparecerán aquí.",
			filter: "No se encontró nada para su búsqueda",
			message: "Cambie sus filtros e inténtelo de nuevo",
		},
	},

	boxInfo: {
		user: {
			registration: "Matrícula: {{identificationNumber}}",
			admission: "Admisión: {{admissionDate}}",
			jobTitle: "Cargo",
			department: "Área",
			finishedAt: "Finalizado el",
			manager: "Gerente",
		}
	},

	situations: {
		active: "Activos",
		activeSingular: "Activo",
		inactive: "Inactivos",
		inactiveSingular: "Inactivo",
		all: "Todos",
		allFemale: "Todas",
		ratings: {
			one: "1",
			two: "2",
			three: "3",
			four: "4",
			five: "5"
		},
		commentsModeration: {
			pending: "Pendiente",
			approve: "Aprobado",
			reprove: "Rechazado"
		}
	},

	auxiliary: {
		lastSeparator: " y"
	},
	booleans: {
		yes: "Sí",
		no: "No",
		true: "Sí",
		false: "No"
	},
	races: {
		white: "Blanco",
		black: "Negro"
	},
	date: {
		dateAndHourSeparator: 'a las',
		dateToDate: 'hasta',
		today: "Hoy",
		yesterday: "Ayer",
		allDay: "Todo el día"
	},

	sw: {
		title: "Actualización",
		content: "Existe una nueva versión de la aplicación, necesitamos que haga clic en el botón de abajo para recargar la página.",
		actions: {
			reload: {
				text: "Recargar página"
			}
		}
	},
	recorderAudio: {
		rejectedPermission: "Es necesario permitir el acceso a su micrófono",
		timedOut: "Tiempo límite agotado, envíe o grabe otro audio"
	},
	snackBar: {
		messages: {
			success: "Éxito",
			error: "Error",
			internalServerError: "Se produjo un error de conexión con el servidor"
		},
		actions: {
			close: {
				text: "Cerrar"
			},
			reload: {
				text: "Recargar página"
			},
			restore: {
				text: "Deshacer"
			}
		}
	},
	errors: {
		moduleImport: "Existe una nueva versión de la aplicación, necesitamos que haga clic en el botón de abajo para recargar la página.",
		connectionDown: "Ha perdido el acceso a la red",
		permissionError: "No tiene permiso para acceder a esta página.",
		connectionComeBack: "Su conexión ha sido restablecida",
		apiIsNotFound: "Se perdió la conexión con el servidor, comuníquese con el soporte",
		apiError: "No pude cargar algún elemento de esta página. Si esto interfiere con su uso, comuníquese con el soporte.",
	},

	dialog: {
		ariaLabel: "Cuadro de diálogo",
		actions: {
			close: "Cerrar",
			agree: "De acuerdo"
		}
	},
	localActions: {
		filters: {
			text: "Filtros",
			tooltip: "Filtros",
			badge: "Número de filtros activos"
		},
		generateReport: {
			text: "Generar informe",
			tooltip: "Generar informe"
		}

	},
	confirmDialog: {
		title: "Atención",
		body: "¿Desea confirmar los cambios realizados?",
		action: "Sí",
		cancel: "No"
	},

	listActions: {
		edit: {
			text: "Editar"
		},
		delete: {
			text: "Eliminar"
		},
		close: {
			text: "Cerrar"
		},
		save: {
			text: "Guardar"
		},
		duplicate: {
			text: "Duplicar"
		},
		remove: {
			text: "Quitar"
		},
		recover: {
			text: "Restaurar"
		},
		inactive: {
			text: "Inactivar"
		},
		restorePassword: {
			text: "Restaurar contraseña"
		},
		view: {
			text: "Visualizar"
		},
		reprove: {
			text: "Rechazar"
		},
		approve: {
			text: "Aprobar"
		},
		viewChanges: {
			text: "Ver cambios"
		},
		finish: {
			text: "Finalizar"
		},
		active: {
			text: "Activar"
		},
		resendEmail: {
			text: "Reenviar e-mail de confirmación"
		}
	},
	filters: {
		title: "Filtros",
		actions: {
			close: {
				text: "Cerrar"
			},
			clear: {
				text: "Limpiar"
			},
			save: {
				text: "Buscar"
			}
		},
		fields: {
			active: {
				label: "Situación",
				placeholder: "Elija la situación",
				url: "situacao",
			}
		}
	},
	dynamicFields: {
		select: {
			placeholder: "Seleccione una de las opciones"
		}
	},
	form: {
		updateSubTitle: "",
		createSubTitle: "",
		select: {
			lastSeparator: " y",
			nothing: "Ninguno",
			nothingFemale: "Ninguna",
		},
		dateRange: {
			initPlaceholder: "Fecha inicial",
			finalPlaceholder: "Fecha final"
		},
		input: {
			password: {
				show: "Mostrar contraseña",
				hide: "Ocultar contraseña"
			}
		},
		editor: {
			link: {
				label: "Enlace",
				placeholder: "Ingrese el enlace",
				save: 'Guardar',
				edit: 'Editar',
				remove: 'Quitar',
				visitUrl: 'Visitar enlace'
			}
		},
		chips: {
			remove: "Eliminar elemento",
			notFound: "Elementos no encontrados"
		},
		autocomplete: {
			notFound: "Elementos no encontrados",
			clear: "Limpiar"
		},
		errors: {
			maxShouldBeGreaterThanMin: "El valor del número máximo debe ser mayor que el valor del número mínimo",
			minlength: "Mínimo de {{ minlength }} caracteres",
			maxlength: "Máximo de {{ maxlength }} caracteres",
			min: "El valor mínimo permitido es {{ min }}",
			max: "El valor máximo permitido es {{ max }}",
			email: "El e-mail es inválido",
			invalidOption: "Seleccione una opción válida",
			onlyNumber: "Ingrese solo números",
			passwordConfirmation: "Las contraseñas deben ser iguales",
			required: "El campo es obligatorio",
			matDatepickerParse: "La fecha es inválida",
			matStartDateInvalid: "La fecha es inválida",
			matEndDateInvalid: "La fecha es inválida",
			matDatepickerFilter: "La fecha es inválida",
			dateRangeMessageSeparated: "La fecha es inválida",
			url: "La URL es inválida",
			color: "El color es inválido",
			cnpj: "El CNPJ es inválido",
			cpfOrEmail: "El e-mail o documento es inválido",
			cep: "El CEP es inválido",
			cpf: "El documento es inválido",
			hourMinute: "La hora es inválida",
			phone: "El teléfono es inválido",
			cnh: "La CNH es inválida",
			licensePlate: "La placa es inválida",
			overSize: "El tamaño de los archivos no puede superar los 200 megabytes",
			invalidStartEndTime: "El horario final no debe ser menor que el horario inicial",
			notANumber: "No es un número",
			whiteSpaces: "No puede contener solo espacios en blanco"
		},
		chooseIcon: {
			messages: {
				text: "Seleccionado: {{ icon }}",
				notFound: "Ninguno agregado",
			},
			buttons: {
				add: {
					text: "Agregar"
				},
				change: {
					text: "Cambiar"
				}
			},
			dialog: {
				title: "Elige un ícono",
				noResults: "Íconos no encontrados",
				form: {
					fields: {
						search: {
							label: "Buscar (en inglés)",
							placeholder: "Ingrese el nombre, categoría o etiqueta del ícono"
						}
					}
				},
				buttons: {
					showMore: {
						text: "Mostrar más"
					}
				}
			}
		},
		actions: {
			clear: {
				text: "Limpiar formulario"
			},
			cancel: {
				text: "Cancelar"
			},
			create: {
				text: "Crear"
			},
			save: {
				text: "Guardar"
			},
			close: {
				text: "Cerrar"
			}
		}
	},

	notFound: {
		breadcrumbName: "No encontrado",
		title: "Página no encontrada",
		description: `
                Intentó acceder a una página que no existe. Haga clic en el botón de abajo para volver.
            `,
		actions: {
			back: {
				text: "Volver"
			}
		}
	},
	noAccess: {
		breadcrumbName: "Sin acceso",
		title: "Sin permiso de acceso",
		description: `
                No tiene permiso para acceder a esta página. Haga clic en el botón de abajo para volver.
            `,
		actions: {
			back: {
				text: "Volver"
			}
		}
	},

	table: {
		expanded: {
			column: "Columna expansible",
			row: "Fila expansible"
		},
		noResults: {
			text: "Resultados no encontrados",
			description: "Intente registrar o filtrar un elemento"
		},
		paginator: {
			firstPageLabel: "Primera página",
			lastPageLabel: "Última página",
			itemsPerPageLabel: "Elementos por página",
			nextPageLabel: "Página siguiente",
			previousPageLabel: "Página anterior",
			rangeLabel: "{{ index }} hasta {{ limit }} de {{ length }}",
			perPageUrl: "per-page",
			pageUrl: "page"
		},
		columns: {
			actions: "",
			dragAction: {
				tooltip: "Arrastre para mover esta fila"
			},
			selection: {
				all: {
					select: "Seleccionar todas las filas",
					deselect: "Deseleccionar todas las filas"
				},
				row: {
					select: "Seleccionar esta fila",
					deselect: "Deseleccionar esta fila"
				}
			}
		}
	},
	fileViewer: {
		actions: {
			download: "Descargar",
			view: "Visualizar",
			close: "Cerrar",
		}
	},
	fileRenderer: {
		notFound: {
			label: "Archivo no disponible",
			description: "No fue posible encontrar este archivo",
		}
	},
	filePicker: {
		actions: {
			addMedia: "Agregar adjunto",
			changeMedia: "Reemplazar adjuntos",
		},
		noResults: {
			label: "Ningún adjunto agregado"
		}
	},
	hintBox: {
		labels: {
			expanded: "Ocultar sugerencias de uso",
			notExpanded: "Mostrar sugerencias de uso",
		},
	},
	dynamicForm: {
		drawer: {
			title: "Agregar nuevos campos",
			fields: {
				fieldName: {
					label: "Nombre del campo",
					placeholder: "El nombre que el colaborador verá al inscribirse."
				},
				fieldType: {
					label: "Tipo de campo",
					placeholder: "¿Un texto? ¿Una lista de opciones?"
				},
				required: {
					label: "¿Es obligatorio?",
					tooltip: "Si marca este campo, el colaborador no podrá enviar el formulario sin completar esta información."
				},
				onlyForParticipant: {
					label: "¿Mostrar este campo solo para el participante?",
					tooltip: "Si marca este campo, solo el participante que el colaborador agregue podrá verlo."
				},
				maxLength: {
					label: "Tamaño máximo de caracteres",
					placeholder: "¿Cuántos números o letras puede ingresar el colaborador como máximo?"
				},
				maxNumber: {
					label: "Valor máximo del número",
					placeholder: "¿Cuánto puede ingresar el colaborador en este campo?"
				},
				minNumber: {
					label: "Valor mínimo del número",
					placeholder: "¿Cuánto puede ingresar el colaborador en este campo?"
				},
			},
			configurations: {
				options: {
					title: "Opciones de la lista",
					tooltip: "Aquí puede informar las opciones que se mostrarán en esta lista",
					fields: {
						name: {
							label: "Nombre de la opción",
							placeholder: "Así es como el colaborador verá esta opción"
						}
					}
				},
			},
			actions: {
				save: {
					text: "Guardar"
				},
				addField: {
					text: "Agregar campo al formulario"
				},
				editField: {
					text: "Modificar campo en el formulario"
				},
				cancelUpdate: {
					text: "Cancelar edición"
				},
			},
			errors: {
				fieldNameExists: "Ya existe un campo con este nombre. Por favor, ingrese otro valor"
			}
		},
		noResults: {
			label: "Ningún campo fue registrado en el formulario",
			description: 'Haga clic en "+ Agregar campo al formulario" para agregarlos'
		},
		fieldActions: {
			edit: {
				text: "Editar este campo"
			},
			move: {
				text: "Mover la posición de este campo"
			},
			delete: {
				text: "Eliminar este campo del formulario"
			},
		}
	},
	confirmAction: {
		title: "¿Está seguro de que desea ejecutar esta acción?",
		body: "Esta acción no podrá ser revertida",
		cancel: "Cancelar",
		delete: "Sí, ejecutar",
	},
	advancedEditor: {
		defaultActions: {
			font: {
				tooltip: "Fuente"
			},
			header: {
				tooltip: "Títulos"
			},
			size: {
				tooltip: "Definir tamaño de fuente",
				placeholder: "Tamaño"
			},
			bold: {
				tooltip: "Negrita"
			},
			italic: {
				tooltip: "Cursiva"
			},
			underline: {
				tooltip: "Subrayado"
			},
			strike: {
				tooltip: "Tachado"
			},
			align: {
				tooltip: "Alineaciones"
			},
			list: {
				ordered: {
					tooltip: "Agregar lista ordenada"
				},
				bullet: {
					tooltip: "Agregar lista no ordenada"
				},
			},
			image: {
				tooltip: "Agregar imagen"
			},
			link: {
				tooltip: "Insertar enlace"
			},
			background: {
				tooltip: "Seleccionar color de fondo"
			},
			color: {
				tooltip: "Seleccionar color del texto"
			},
			variables: {
				tooltip: "Seleccionar variable",
				placeholder: "Variables"
			},
		},
		options: {}
	},
	list: {
		noResults: {
			text: "Resultados no encontrados",
			description: "Registre un elemento y aparecerá aquí",
		},
		moreResults: {
			text: "Mostrar más"
		}
	},


	footer: {
		title: "Desarrollado por"
	},
	developedBy: {
		title: "Joinin"
	},
	accountOutOfConnection: {
		label: "Problemas con su autenticación, ¡comuníquese con el soporte técnico! - ACT001"
	},
	globalLoading: {
		message: "",
		login: "Iniciando sesión en {{ projectName }}",
		loading: "Cargando {{ projectName }}",
		logout: "Cerrando sesión de {{ projectName }}",
		switchUser: "Cambiando de usuario",
		joinWithOtherUser: "Iniciando sesión con otro usuario",
		authentication: "Autenticando el usuario",
	},
	tabs: {
		urlName: "pestaña"
	},


	radioVote: {
		quantity: "Cantidad de votos"
	},
	basicCarousel: {
		actions: {
			next: {
				text: "Siguiente imagen"
			},
			previous: {
				text: "Imagen anterior"
			}
		}
	},

	actions: {
		showMore: "Mostrar más",
		seeAttachments: "Ver adjuntos",
		addObservation: "Observaciones",
		observationAndAttachments: "Adjuntos / observaciones",
		setAttachments: "Agregar adjuntos"
	},

	notifications: {},
	unauthorizedPage: {
		redirect: {
			back: "Volver"
		}
	},
	tooltipUser: {
		edit: "Editar",
		chat: "Conversar",
		congratulate: "Dar felicitaciones",
		onVacation: "En período de vacaciones",
		myProfile: "Mi perfil",
		profile: "Ver perfil"
	},


	uuidAuthentication: {
		messages: {
			notFound: "Cuenta no encontrada"
		}
	},

	attachments: {
		open: "Abrir adjunto",
		remove: "Quitar adjunto"
	},

	languageSwitcher: {
		label: "Idioma",
		confirmTitle: "¿Deseas cambiar el idioma a \"{{name}}\"?",
		confirmBody: "La página necesita ser recargada para aplicar los cambios.",
		confirm: "Confirmar",
		cancel: "Cancelar",
		// eslint-disable-next-line @typescript-eslint/naming-convention
		languages: {
			// eslint-disable-next-line @typescript-eslint/naming-convention
			"pt-BR": "Português (BR)",
			// eslint-disable-next-line @typescript-eslint/naming-convention
			"en-US": "English (US)",
			// eslint-disable-next-line @typescript-eslint/naming-convention
			"es-ES": "Español (ES)",
		}
	},

};
